var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7406 15.8512C26.7406 16.2454 26.5953 16.6233 26.3368 16.902C26.0782 17.1807 25.7276 17.3373 25.3619 17.3373H16.6305V26.7489C16.6305 27.143 16.4853 27.521 16.2267 27.7997C15.9682 28.0784 15.6175 28.2349 15.2519 28.2349C14.8862 28.2349 14.5356 28.0784 14.277 27.7997C14.0185 27.521 13.8732 27.143 13.8732 26.7489V17.3373H5.14183C4.77619 17.3373 4.42552 17.1807 4.16698 16.902C3.90843 16.6233 3.76318 16.2454 3.76318 15.8512C3.76318 15.4571 3.90843 15.0791 4.16698 14.8004C4.42552 14.5218 4.77619 14.3652 5.14183 14.3652H13.8732V4.95357C13.8732 4.55945 14.0185 4.18147 14.277 3.90278C14.5356 3.62409 14.8862 3.46753 15.2519 3.46753C15.6175 3.46753 15.9682 3.62409 16.2267 3.90278C16.4853 4.18147 16.6305 4.55945 16.6305 4.95357V14.3652H25.3619C25.7276 14.3652 26.0782 14.5218 26.3368 14.8004C26.5953 15.0791 26.7406 15.4571 26.7406 15.8512Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddAccount);
export default __webpack_public_path__ + "static/media/addAccount.2c2cb51b0868fd9ff1f182a20d3426ec.svg";
export { ForwardRef as ReactComponent };